import React from "react";

export const AddNights: React.FunctionComponent = (props) => {
  return <>Add Nights</>;
};
